import React from "react";
import styles from "./Astrolog.module.css";
import NavigationBar from "../../components/common/NavigationBar";
import Button from "../../components/common/Button";
import { sendAskAstroAction } from "../../services/api/astroChat";
import { useAuthStore } from "../../store/authStore";

const AstrologPage: React.FC = () => {
  const tg_id = useAuthStore((state) => state.tg_id);

  const handleGoToChat = async () => {
    if (!tg_id) {
      alert("Ошибка авторизации: Telegram ID не найден");
      return;
    }
    try {
      await sendAskAstroAction(tg_id);
    } catch (err) {
      console.error("❌ Ошибка отправки в бот:", err);
    }
    window.Telegram?.WebApp?.close();
  };

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.illustration}
          style={{ backgroundImage: 'url("/illustration/astrologyCircle.png")' }}
        />
        <div className={styles.questionBlock}>
          <div className={styles.questionText}>
            Задай свой вопрос астрологу — получи персональный разбор на основе твоей натальной карты
            прямо в чате.
            <div className={styles.questionExamples}>
              Например, ты можешь спросить:
              <ul>
                <li>Когда ждать перемен в работе?</li>
                <li>Что меня ждёт в личной жизни?</li>
                <li>Стоит ли менять город?</li>
                <li>В чём мои сильные стороны?</li>
              </ul>
            </div>
            <span style={{ display: "block", marginTop: 12 }}>
              Стоимость каждого вопроса — <b>100 Stars</b>.
            </span>
          </div>
          <Button className={styles.buttonWrapper} onClick={handleGoToChat}>
            Задать вопрос
          </Button>
        </div>
      </div>
      <NavigationBar active="astrolog" />
    </>
  );
};

export default AstrologPage;
